import styled, { css } from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius, borderWidth } from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Section = styled.div<{ $isOpen?: boolean; $compact?: boolean }>`
  border-bottom: ${borderWidth[1]} solid ${rawColors.stroke[200]};

  ${({ $isOpen }) =>
    $isOpen
      ? css`
          display: flex;
          flex-direction: column;
          gap: ${spacing[4]};
          padding: ${spacing[4]} ${spacing[3]} ${spacing[3]};
        `
      : css`
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: ${spacing[3]};
          min-height: 50px;
          padding: ${spacing[3]};
          cursor: pointer;

          &:hover {
            background-color: ${rawColors.structural[50]};
          }
        `}
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
`;

export const LabelGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
`;

export const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: ${rawColors.text.mediumEmphasis};
  flex-shrink: 0;
`;

export const Label = styled.span<{ $isOpen?: boolean }>`
  ${({ $isOpen }) =>
    $isOpen ? typographyMixin("caption", 3) : typographyMixin("caption", 4)}
  color: ${({ $isOpen }) =>
    $isOpen ? rawColors.text.highEmphasis : rawColors.text.mediumEmphasis};
`;

export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px ${spacing[2]};
  background-color: ${rawColors.stroke[200]};
  border: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.sm};
  ${typographyMixin("overline", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const Chevron = styled.span<{ $isOpen?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: ${rawColors.text.mediumEmphasis};
  flex-shrink: 0;
  transition: transform 0.2s ease;
  transform: rotate(${({ $isOpen }) => ($isOpen ? "180deg" : "0deg")});
`;

export const PillGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing[2]};
`;

/** Used-in expanded sections — full-width link rows, 8px stack. */
export const LinkRowStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;
